import { useEffect, useRef } from "react";
import type { ChatMessage } from "@/types";
import { MessageBubble } from "./MessageBubble";

interface MessageListProps {
  messages: ChatMessage[];
}

export const MessageList = ({ messages }: MessageListProps) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    scrollRef.current?.scrollTo({
      top: scrollRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages]);

  return (
    <div
      ref={scrollRef}
      className="flex-1 space-y-2 sm:space-y-3 overflow-y-auto rounded-xl sm:rounded-2xl bg-gradient-to-b from-white/60 to-white/30 p-2 sm:p-3 shadow-inner dark:from-white/5 dark:to-white/10 max-h-[60vh]"
    >
      {messages.length === 0 ? (
        <div className="grid h-full place-items-center text-xs sm:text-sm text-muted-foreground px-4">
          Start a chat to see the MCP stream come alive.
        </div>
      ) : (
        messages.map(message => <MessageBubble key={message.id} message={message} />)
      )}
    </div>
  );
};
